/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/revolve；
 * 2. 负责定义旋转切除特征原型对象；
 * 3. 该类仅承载“切除”语义，公共骨架复用旋转族基类。
 */

import { RevolveFeaturePrototype } from './RevolveFeaturePrototype';

/**
 * 旋转切除特征原型。
 */
export class CutRevolveFeaturePrototype extends RevolveFeaturePrototype {}
